import React, { useEffect, useState, useContext } from 'react';
import Navbar from '../Layout/Navbar/Navbar';
import Footer from '../Layout/Footer/Footer';
import { FilterContext } from '../../context/FilterContext';
import { useParams, Link } from 'react-router-dom';

const importAll = (require) =>
  require.keys().reduce((acc, next) => {
    acc[next.replace('./', '')] = require(next);
    return acc;
  }, {});

function Spec({ label, value }) {
  if (!value && value !== 0) return null;
  return (
    <div className="flex items-center justify-between border-b border-ink/10 py-3">
      <dt className="text-sm font-light text-ink-500">{label}</dt>
      <dd className="text-sm font-medium text-ink">{value}</dd>
    </div>
  );
}

function Producto() {
  const { id } = useParams();
  const { state } = useContext(FilterContext);
  const [prod, setProd] = useState(null);
  const [imagesForProduct, setImagesForProduct] = useState([]);
  const [selectedImage, setSelectedImage] = useState('');
  const imgs = importAll(require.context('../../assets/images/productos', true));

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [id]);

  useEffect(() => {
    if (!id) return;
    const pr = state.productos.filter((p) => p.codigo == id)[0];
    setProd(pr);
  }, [id, JSON.stringify(state.productos)]);

  useEffect(() => {
    const imagenes = Object.keys(imgs)
      .map((im) => (im.split('/')[0] === prod?.codigo ? imgs[im] : null))
      .filter(Boolean);
    setImagesForProduct(imagenes);
    setSelectedImage(imagenes[0]);
  }, [prod, JSON.stringify(imgs)]);

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar checkScroll={false} />

      <main className="flex-1 pt-28 md:pt-32">
        <div className="mx-auto max-w-7xl px-6 pb-20 md:px-10 md:pb-28">
          {/* Breadcrumb */}
          <nav className="mb-8 flex items-center gap-2 text-sm font-light text-ink-400">
            <Link to="/" className="transition-colors hover:text-brand-600">
              Inicio
            </Link>
            <span>/</span>
            <Link to="/productos" className="transition-colors hover:text-brand-600">
              Productos
            </Link>
            <span>/</span>
            <span className="text-ink">{prod?.codigo || id}</span>
          </nav>

          {prod ? (
            <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
              {/* Gallery */}
              <div className="flex flex-col-reverse gap-4 md:flex-row">
                {imagesForProduct.length > 1 && (
                  <div className="flex gap-3 md:flex-col">
                    {imagesForProduct.map((im, i) => (
                      <button
                        key={i}
                        onClick={() => setSelectedImage(im)}
                        className={`h-20 w-20 shrink-0 overflow-hidden rounded-xl border-2 transition-all ${
                          selectedImage === im
                            ? 'border-brand-500'
                            : 'border-transparent opacity-70 hover:opacity-100'
                        }`}
                      >
                        <img src={im} alt="" className="h-full w-full object-cover" />
                      </button>
                    ))}
                  </div>
                )}
                <div className="flex-1 overflow-hidden rounded-3xl bg-ink-50">
                  <img
                    src={selectedImage}
                    alt={prod.codigo}
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>

              {/* Info */}
              <div className="lg:pt-4">
                <p className="text-xs font-medium uppercase tracking-wider2 text-brand-600">
                  Código {prod.codigo}
                </p>
                <h1 className="mt-3 font-display text-4xl font-medium text-ink md:text-5xl">
                  {prod.nombre}
                </h1>

                <dl className="mt-8 border-t border-ink/10">
                  <Spec label="Ancho" value={prod.ancho && `${prod.ancho} cm`} />
                  <Spec label="Alto" value={prod.alto && `${prod.alto} cm`} />
                  <Spec
                    label="Profundidad"
                    value={prod.profundidad && `${prod.profundidad} cm`}
                  />
                  <Spec label="Zócalo" value={prod.nombre_zocalo} />
                  <Spec label="Ambiente" value={prod.nombre_ambiente} />
                  <Spec label="Aplicación" value={prod.nombre_aplicacion} />
                </dl>

                {prod.colores?.length > 0 && (
                  <div className="mt-8">
                    <p className="mb-3 text-sm font-medium text-ink">
                      Colores disponibles
                    </p>
                    <div className="flex flex-wrap gap-3">
                      {prod.colores.map((color, i) => (
                        <span
                          key={i}
                          title={color.nombre || color.codigo}
                          style={{ backgroundColor: color.codigo }}
                          className="h-9 w-9 rounded-full border border-ink/15 shadow-[inset_0_0_0_2px_rgba(255,255,255,0.6)]"
                        />
                      ))}
                    </div>
                  </div>
                )}

                <div className="mt-10 flex flex-wrap gap-4">
                  <a
                    href={`https://wa.me/+5493515395915?text=${encodeURIComponent(
                      `Hola, quiero hacer un pedido del producto ${prod.codigo} - ${prod.nombre}`,
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-primary"
                  >
                    Consultar por este producto
                  </a>
                  <Link to="/productos" className="btn-ghost">
                    Volver al catálogo
                  </Link>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-32 text-center">
              <div className="h-10 w-10 animate-spin rounded-full border-2 border-ink-200 border-t-brand-500" />
              <p className="mt-4 text-sm font-light text-ink-500">
                Cargando producto…
              </p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Producto;
